import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import * as ch from "./contentHelper";
import * as p from "./popup";
import $ from "jquery";

//--------------------------------------------------------------
//POPULATION
let headline = '<br/>Population';
let addClassName = 'population';

let mapLayerNames = [
  'nuts3-population-1',
  'nuts3-population-2',
  'nuts3-population-3'
];

//add layers to toggleAbleLayers in mapInit
mapLayerNames.forEach(function(layerName){m.addToggleableLayer(layerName);});

let properties = [
  [
    'population-1-2017',
    'population-2-variation-2010-2017',
    'population-3-regions'
  ],

  [
    'population-2-variation-2010-2017',
    'population-1-2017',
    'population-3-regions'
  ],

  [
    'population-3-regions',
    'population-1-2017',
    'population-2-variation-2010-2017'
  ]

];

let valueNames = [
  [
    'Population [2017]',
    'Population Variation<br/>[2017 compared to 2010 in %]',
    'Regions characterisation [2010]'
  ],

  [
    'Population Variation<br/>[2017 compared to 2010 in %]',
    'Population [2017]',
    'Regions characterisation [2010]'
  ],

  [
    'Regions characterisation [2010]',
    'Population [2017]',
    'Population Variation<br/>[2017 compared to 2010 in %]'
  ]
];

let valueDescriptions = [
  [
    '',
    '',
    ''
  ],

  [
    '',
    '',
    ''
  ],

  [
    '',
    '',
    ''
  ],
];

let infoBox = [
  [
    ['Source: Eurostat;<br/>Code: demo_r_pjangrp3'],
    ['Source: Eurostat;<br/>Code: demo_r_pjanaggr3<br/>Notes: For Poland the variation refers to<br/>2014 - 2016 - due to limited data availability)'],
    ['Source: Eurostat:<br/>Urban-rural typology for NUTS level 3 regions']
  ],

  [
    ['Source: Eurostat;<br/>Code: demo_r_pjanaggr3<br/>Notes: For Poland the variation refers to<br/>2014 - 2016 - due to limited data availability)'],
    ['Source: Eurostat;<br/>Code: demo_r_pjangrp3'],
    ['Source: Eurostat:<br/>Urban-rural typology for NUTS level 3 regions']
  ],

  [
    ['Source: Eurostat:<br/>Urban-rural typology for NUTS level 3 regions'],
    ['Source: Eurostat;<br/>Code: demo_r_pjanaggr3'],
    ['Source: Eurostat;<br/>Code: demo_r_pjanaggr3<br/>Notes: For Poland the variation refers to<br/>2014 - 2016 - due to limited data availability)']
  ]
];

let addTextAfterValue = [
  [
    [''],
    ['%'],
    ['']
  ],

  [
    ['%'],
    [''],
    ['']
  ],

  [
    [''],
    [''],
    ['%'],
  ]
];


//--------------------------------------------------------------

for(let i = 0; i < properties.length; i++){
  m.map.on('click',mapLayerNames[i], function (e) {
    p.getPopup(
      e,
      addClassName,
      headline,
      properties[i],
      valueNames[i],
      valueDescriptions[i],
      infoBox[i],
      addTextAfterValue[i] );
  });
};
